var map = {
	"./afrika.svg": "/sIc",
	"./alaska.svg": "ADQp",
	"./arabien.svg": "IBQ/",
	"./asien.svg": "L8Y3",
	"./australien.svg": "t3si",
	"./bahnreisen.svg": "NYMp",
	"./chinareisen.svg": "aAAH",
	"./geschaeftsreisen.svg": "ZqAB",
	"./glur.svg": "NQNE",
	"./golfreisen.svg": "qOtS",
	"./heliskiingreisen.svg": "GvbR",
	"./hochzeitsreisen.svg": "mPpp",
	"./indienreisen.svg": "/Cfe",
	"./island.svg": "EWoV",
	"./japan.svg": "+TKD",
	"./kanada.svg": "ZVHr",
	"./karibik.svg": "3h9V",
	"./kira.svg": "lRDi",
	"./knecht-old.svg": "FkwT",
	"./knecht.svg": "yMH1",
	"./latino.svg": "ce57",
	"./malediven.svg": "mUe9",
	"./mauritiusreisen.svg": "E033",
	"./neuseeland.svg": "oTyw",
	"./premiumreisen.svg": "ZA4L",
	"./russland.svg": "fvDG",
	"./seychellen.svg": "OFRI",
	"./skandinavien.svg": "Bv5o",
	"./sportlivereisen.svg": "qmWu",
	"./sportreisen.svg": "52b+",
	"./sri-lanka.svg": "wkr6",
	"./suedamerika.svg": "QVql",
	"./suedsee.svg": "xk/x",
	"./trainingslagerreisen.svg": "RQCb",
	"./usa.svg": "2VxS",
	"./zentralamerika.svg": "6hev",
	"./zentralasien.svg": "Bg/z"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31ZR";